import { css } from '@terra/ui-styled-system';

export const scrollableStyles = css({
  borderRadius: 'md',
  paddingInline: 3,
  paddingBlockStart: 2,
  paddingBlockEnd: '48px',
  overflowY: 'auto',
  overflowX: 'hidden',
  WebkitOverflowScrolling: 'touch',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
  scrollbarWidth: 'none',
  _hover: {
    scrollbarWidth: 'thin',
    scrollbarColor: 'var(--colors-gray-300) var(--colors-gray-100)',
  },
});

export const scrollableStylesFlushTop = css({
  borderRadius: 'md',
  paddingInline: 3,
  paddingBlockStart: 0,
  paddingBlockEnd: '48px',
  overflowY: 'auto',
  overflowX: 'hidden',
  WebkitOverflowScrolling: 'touch',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
  scrollbarWidth: 'none',
  _hover: {
    scrollbarWidth: 'thin',
    scrollbarColor: 'var(--colors-gray-300) var(--colors-gray-100)',
  },
});
